import { User, Users } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const UserIcon = DeckardIconWrapper({ Icon: User, DoubleIcon: Users });
